/*eslint-disable*/
import { STYLES } from "config";
import { useEffect, useState } from "react";
import {
    MenuItem,
    Select
} from '@mui/material';
import { useSelector } from "react-redux";

import {
    Button,
    Input,
} from "reactstrap";

import CustomDropDownPicker from "./CustomDropDownPicker";


import SearchWithSuggestions from "./CustomSearchbar";
const styles = {
    container: {
        padding: "5px",
        backgroundColor: STYLES.PRIMARY_APP_CLR,
        borderRadius: "4px",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        width: "100%",
    },
    divider: {
        height: "1px",
        backgroundColor: STYLES.WEB_APP_FONT_CLR,
        margin: "10px 0",
    },

    section: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "5px",
    },

    subSection: {
        display: "flex",
        alignItems: "center",
        padding: "10px",
    },

    standardButton: { backgroundColor: STYLES.PRIMARY_BUTTON_CLR, color: "white" },

    selectorButtons: { backgroundColor: STYLES.PRIMARY_BUTTON_CLR, color: "white", width: "8px", hight: "10px", display: "flex", alignItems: "center", justifyContent: "center" },

    whiteFont: { color: "white", fontSize: "12px", fontWeight: "bold" },

    inputStyle: {
        borderWidth: 1,
        borderColor: STYLES.TERTIARY_APP_CLR,
        height: 54,
        backgroundColor: "white",
        fontSize: 16,
        borderRadius: 2,
        color: "grey",
        paddingRight: 30,
    },

    advancedFilter: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
    },
    advancedFilterRow: {
        gap: "10px",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        padding: "5px",
    },
    advancedFilterSearchClearRow: {
        gap: "10px",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "left",
        width: "100%",
        padding: "5px",
    },

};

const CustomAdvanceListingsFilter = ({
    setView,
    setDisplayedListings,
    currentListings,
    filteredListings,
    setFilteredListings
}) => {
    //usestates
    const [currentPage, setCurrentPage] = useState(1);
    const [advanced, setAdvanced] = useState(false);
    const [brokerList, setBrokerList] = useState([]);
    const [propertyTypeList, setPropertyTypeList] = useState([]);
    const [itemsPerPage, setitemsPerPage] = useState(10)
    const [filterstate, setFilterState] = useState({
        industrialCommercial: false,
        sizeRangeMin: false,
        sizeRangeMax: false,
        Proptype: [],
        Broker: [],
        web_Ref_No: "",
    });


    //constants
    const usedListings = filteredListings.length > 0 ? filteredListings : currentListings;
    const totalPages = Math.ceil(usedListings.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;

    const usageTypes = [
        { value: "Commercial", label: "Commercial", },
        { value: "Industrial", label: "Industrial", },
    ]
    const propTypes = [
        "warehouse",
        "office",
        "retail",
        "vacant land",
        "industrial yard",
        "workshop",
        "restaurant",
        "showroom",
        "investment",
        "building",
        "mini factory",
        "factory",
        "business",
        "hotel",
        "full floor",
        "storage unit",
        "guesthouse",
        "medical suite",
        "business centre",
        "service station",
        "small holding"]
    //Reducer
    const brokers = useSelector((state) => state.brokers.users);
    const auth = useSelector((state) => state.auth);

    //UseEffect to set intial display of data

    useEffect(() => {

        setDisplayedListings(usedListings); // Clear displayed listings when currentPage changes

        console.log('itemsPerPage', itemsPerPage)

        const displayedListings = usedListings.slice(
            startIndex,
            startIndex + itemsPerPage
        );

        setDisplayedListings(displayedListings);
    }, [currentPage, filteredListings, currentListings, itemsPerPage])




    useEffect(() => {
        let arr = [];
        if (brokers) {
            for (let index = 0; index < brokers.length; index++) {
                const element = brokers[index];

                // Populate the list with all brokers, remove brokerHomeOffice filter
                if (element.brokerHomeOffice === auth?.info?.profile?.adminHomeOffice) {
                    arr.push({
                        value: element.id, // The broker ID (or name if preferred)
                        label: `${element.firstName} ${element.lastName}`, // Broker name
                    });
                }
            }
            setBrokerList(arr.sort((a, b) => a.label.localeCompare(b.label)));
        }


        let propArr = [];
        if (propTypes) {
            for (let index = 0; index < propTypes.length; index++) {
                const element = propTypes[index];

                propArr.push({
                    value: element,
                    label: element,
                });

            }
            setPropertyTypeList(propArr);
        }

    }, [brokers]);


    //functions
    const filterListings = (filter, info) => {
        setFilterState({
            ...filterstate,
            [filter]: info,
        });
    };

    const clearFilter = () => {
        setFilterState({
            industrialCommercial: false,
            sizeRangeMin: false,
            sizeRangeMax: false,
            Proptype: [],
            Broker: [],
            web_Ref_No: "",
        }
        )
    }

    const filter = () => {

        let filtered = [];
        let error = false;

        if (filterstate) {
            if (
                filterstate.sizeRangeMin !== "" &&
                filterstate.sizeRangeMax !== "" &&
                parseInt(filterstate.sizeRangeMin) > parseInt(filterstate.sizeRangeMax)
            ) {
                alert("Min Filter Size cannot be greater than max size");
                return;
            }

            currentListings.map((listings) => {
                let brokerMatch = false;


                if (filterstate.Broker.length === 0) {
                    brokerMatch = true;
                } else {
                    for (let index = 0; index < filterstate.Broker.length; index++) {
                        if (listings.userdetials?.id === filterstate.Broker[index]) {
                            brokerMatch = true;

                        }
                    }
                }


                const usageTypeMatch = ((!filterstate.industrialCommercial) || (filterstate.industrialCommercial === listings.industrialCommercial));

                const sizeMatch =
                    (!filterstate.sizeRangeMin && !filterstate.sizeRangeMax) ||
                    (parseInt(filterstate.sizeRangeMin) <= parseInt(listings.gla) &&
                        parseInt(filterstate.sizeRangeMax)) >= parseInt(listings.gla);

                let typeOfPropertyMatch = false;

                if (filterstate.Proptype.length === 0) {
                    typeOfPropertyMatch = true;
                } else {
                    for (let index = 0; index < filterstate.Proptype.length; index++) {
                        // Convert both to lowercase for case-insensitive comparison
                        if (
                            String(listings.typeOfProperty || "").toLowerCase() ===
                            String(filterstate.Proptype?.[index] || "").toLowerCase()
                        ) {
                            typeOfPropertyMatch = true;
                        }
                    }
                }


                const webRefMatch =
                    !filterstate.web_Ref_No ||
                    listings?.web_Ref_No === filterstate.web_Ref_No;

                // Check if all conditions are met
                if (brokerMatch && typeOfPropertyMatch && sizeMatch && webRefMatch && usageTypeMatch) {
                    filtered.push(listings);
                }
            });

            if (!error) {
                if (filtered.length > 0) {
                    setFilteredListings(filtered);
                    alert(`Filter Set \n Number of listings: ${filtered.length}`);
                } else {
                    alert("No listings match the selected filters.");
                }
            }
        } else {
            alert("Please enter search options!");
        }
    };


    //Retrun of the screen
    return <div style={styles.container}>

        <div style={styles.section}>

            {!advanced && (<>
                <div style={styles.subSection}>

                    <SearchWithSuggestions
                        currentListings={currentListings}
                        setFilteredListings={setFilteredListings}
                    />


                    {/* <Input
                        fullWidth
                        type="text"
                        style={{ ...styles.inputStyle, borderColor: "#f00000" }}
                        placeholder="Search by Keyword"

                        onChange={(e) => { }}
                    /> */}
                </div>

                <div style={styles.subSection}>

                    <Button
                        type="submit"
                        style={styles.standardButton}
                        onClick={() => {
                            setAdvanced(true);
                        }}
                    >
                        Advanced Filter
                    </Button>

                </div>
            </>)}

            {advanced && (<>
                <div style={styles.advancedFilter}>

                    <div style={styles.advancedFilterRow}>
                        <Input
                            fullWidth
                            type="number"
                            style={styles.inputStyle}
                            placeholder="min size"
                            onChange={(e) => filterListings("sizeRangeMin", e.target.value)}
                            value={filterstate.sizeRangeMin}
                        />

                        <Input
                            fullWidth
                            type="number"
                            style={styles.inputStyle}
                            placeholder="max size"
                            onChange={(e) => filterListings("sizeRangeMax", e.target.value)}
                            value={filterstate.sizeRangeMax}
                        />
                        <div style={{ width: "100%" }}>
                            <CustomDropDownPicker
                                options={brokerList}
                                value={filterstate.Broker}
                                isMulti={true}
                                onChange={(e) => filterListings("Broker", e)}
                                placeholder="Select A Broker"
                            />
                        </div>


                    </div>

                    <div style={styles.advancedFilterRow}>
                        <div style={{ width: "100%" }}>
                            <CustomDropDownPicker
                                options={propertyTypeList}
                                isMulti={true}
                                value={filterstate.Proptype}
                                onChange={(selected) => filterListings("Proptype", selected)}
                                placeholder={"Select Property Type"}
                            />
                        </div>


                    </div>

                    <div style={styles.advancedFilterRow}>
                        <div style={{ width: "100%" }}><CustomDropDownPicker
                            options={usageTypes}
                            isMulti={false}
                            value={filterstate.industrialCommercial}
                            onChange={(e) => filterListings("industrialCommercial", e)}
                            placeholder="Select A Usage Type"
                        />
                        </div>


                    </div>

                    <div style={styles.advancedFilterRow}>

                        <div style={styles.advancedFilterSearchClearRow}>

                            <Button
                                type="submit"
                                style={{ ...styles.standardButton, width: "140px" }}
                                onClick={() => {
                                    filter();
                                }}
                            >
                                Search
                            </Button>

                            <Button
                                type="submit"
                                style={{ ...styles.standardButton, backgroundColor: "red" }}
                                onClick={() => {
                                    clearFilter();
                                }}
                            >
                                Clear
                            </Button>

                        </div>

                        <Button
                            type="submit"
                            style={{ ...styles.standardButton, backgroundColor: "red" }}
                            onClick={() => {
                                setAdvanced(false);
                            }}
                        >
                            Collapse
                        </Button>


                    </div>
                </div>
            </>

            )}


        </div>

        <div style={styles.divider} />

        <div style={styles.section}>

            <div style={styles.subSection}>

                <Button
                    style={styles.selectorButtons}
                    onClick={() => {
                        setView('list');
                    }}
                >
                    <i className="now-ui-icons files_paper" />
                </Button>

                <Button
                    style={styles.selectorButtons}
                    onClick={() => {
                        setView('table');
                    }}
                >
                    <i className="now-ui-icons design_image" />
                </Button>

            </div>

            <div style={{
                ...styles.subSection,
                gap: "10px",
            }}>

                <Select
                    value={itemsPerPage}
                    onChange={(e) => setitemsPerPage(Number(e.target.value))}
                    size="small"   // shorter height
                    sx={{
                        backgroundColor: "white",
                        height: "32px",        // short height
                        '& .MuiSelect-select': {
                            padding: "4px 10px", // reduce inner padding
                        },
                        '& fieldset': {
                            borderColor: '#ccc', // optional border color
                        },
                        '&:hover fieldset': {
                            borderColor: '#999',
                        },
                    }}
                >
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={20}>20</MenuItem>
                    <MenuItem value={30}>30</MenuItem>
                </Select>


                <span style={styles.whiteFont}>
                    {" "}
                    Page {currentPage} of {totalPages}{" "}
                </span>

                <Button
                    style={styles.selectorButtons}
                    onClick={() => {
                        setCurrentPage((prev) => prev - 1);
                    }}
                >
                    <i className="now-ui-icons arrows-1_minimal-left" />
                </Button>

                <Button
                    style={styles.selectorButtons}
                    onClick={() => {
                        setCurrentPage((prev) => prev + 1);
                    }}
                >
                    <i className="now-ui-icons arrows-1_minimal-right" />
                </Button>


            </div>

        </div>

    </div>;
};

export default CustomAdvanceListingsFilter;